import {SET_HORSE_RACING_DATA} from "../actions/actionTypes";

const HorseRacingReducer = (state = {}, action) => {
    switch (action.type) {
        case SET_HORSE_RACING_DATA:
            return action.payload;
        default:
            return state;
    }
};

export default HorseRacingReducer;